export function thumbnailSlider(mainThubnailEl, subThubnailEl) {
  if ($(mainThubnailEl).length && $(subThubnailEl).length) {
    $(`${subThubnailEl} img`).on("click", function () {
      const imgSrc = $(this).attr("src");
      $(this).parents(subThubnailEl).children().removeClass("active");
      $(this).parent().addClass("active");
      $(this)
        .parents(subThubnailEl)
        .siblings(mainThubnailEl)
        .children("img")
        .fadeOut(150, function () {
          $(this)
            .attr("src", imgSrc)
            .on("load", function () {
              $(this).fadeIn();
            });
        });
    });
  }
}
